<template>
	<div id="" class="qualityenterprise ">
		<leftnav class="fl" mkcode="A" itemcode="A-KYJG"></leftnav>
		<div class="bluebanner">
			<div class="centerpage1">
				<h2 class="title">科研机构</h2>
				<p>投资机构就是给政府推荐在专业领域，投资方向上，跟政府的重点产业，新兴产业匹配的投资机构</p>
			</div>
		</div>
		<div :class="isCollapse ? 'index_left2' : 'index_left'" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox" style="padding-bottom: 1px;">
					<div class="right_boxtitle">
						<span class="fl right_title">科研机构</span>
						<div class="fl search-box nz-search-box">
							<span class="searchtype">科研机构</span>
							<input type="text" placeholder="请输入科研机构名称" class="search-input" v-model="searchtext"
								@keydown="searchenter" />
							<button class="search-btn" @click="searchkwfun">查询</button>
						</div>
						<video-teaching :type="1" seat="top"></video-teaching>
					</div>
					<div class="opport-screen-list1">
						<dl class="opport-screen bdbe">
							<dt class="fl">省份地区</dt>
							<dd class="fl">
								<span :class="provinceid == 0 ? 'current a-screen' : 'a-screen'"
									@click="provincechoose(0, 'all'); userdata.provinceText = '全国地区'">全国地区</span>
								<span v-for="(item, index) in provincedata" :key="'prov' + index"
									@click="provincechoose(item.areaId, index); userdata.provinceText = item.areaName"
									:class="item.areaId == provinceid ? 'a-screen current' : 'a-screen'">{{ item.areaName }}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="citydata.length != 0">
							<dt class="fl">城市地区</dt>
							<dd class="fl">
								<span :class="cityid == 0 ? 'current a-screen' : 'a-screen'"
									@click="choosecity(0, 'all'); userdata.cityText = ''">全部</span>
								<span v-for="(item, index) in citydata" :key="'citydata' + index"
									@click="choosecity(item.areaId, index); cityid = item.areaId; userdata.cityText = item.name"
									:data="item.areaId"
									:class="item.areaId == cityid ? 'a-screen current' : 'a-screen'">{{ item.areaName }}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="countydata.length != 0">
							<dt class="fl">区县地区</dt>
							<dd class="fl">
								<span :class="countyid == 0 ? 'current a-screen' : 'a-screen'"
									@click="choosecounty(0); userdata.countyText = ''">全部</span>
								<span v-for="(item, index) in countydata" :key="'countydata' + index"
									@click="choosecounty(item.areaId); countyid = item.areaId; userdata.countyText = item.name"
									:data="item.areaId"
									:class="item.areaId == countyid ? 'a-screen current' : 'a-screen'">{{ item.areaName }}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe">
							<dt class="fl">产业分类</dt>
							<dd class="fl screenop">
								<span @click="chooseNotion(1, 'a', { lable: '全部', value: 0, children: [] })"
									:class="notionCode == 0 ? 'a-screen current' : 'a-screen'">全部</span>
								<span v-for="(item, index) in notionlist" :key="index"
									v-if="item.label.indexOf('先进制造') > -1"
									:class="chooseNotionlist[0] == item.value ? 'a-screen current' : 'a-screen'"
									@click="chooseNotion(1, 'a', item)">{{ item.label }}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="notionlist1.length > 0">
							<dt class="fl titleop">一级产业</dt>
							<dd class="fl">
								<span @click="chooseNotion(2, 'all', fenkd)"
									:class="chooseNotionlist[1] == 0 ? 'a-screen current' : 'a-screen'">全部</span>
								<span v-for="(item, index) in notionlist1" :key="'notionlist1' + index"
									:class="chooseNotionlist[1] == item.value ? 'a-screen current' : 'a-screen'"
									@click="chooseNotion(2, 'a', item)">{{ item.label }}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="notionlist2.length > 0">
							<dt class="fl titleop">二级细分</dt>
							<dd class="fl">
								<span @click="chooseNotion(3, 'all', fenkd)"
									:class="chooseNotionlist[2] == 0 ? 'a-screen current' : 'a-screen'">全部</span>
								<span v-for="(item, index) in notionlist2" :key="'notionlist2' + index"
									:class="chooseNotionlist[2] == item.value ? 'a-screen current' : 'a-screen'"
									@click="chooseNotion(3, 'a', item)">{{ item.label }}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="notionlist3.length > 0">
							<dt class="fl titleop">三级细分</dt>
							<dd class="fl">
								<span @click="chooseNotion(4, 'all', fenkd)"
									:class="chooseNotionlist[3] == 0 ? 'a-screen current' : 'a-screen'">全部</span>
								<span v-for="(item, index) in notionlist3" :key="'notionlist3' + index"
									:class="chooseNotionlist[3] == item.value ? 'a-screen current' : 'a-screen'"
									@click="chooseNotion(4, 'a', item)">{{ item.label }}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="notionlist4.length > 0">
							<dt class="fl titleop">四级细分</dt>
							<dd class="fl">
								<span @click="chooseNotion(5, 'all', fenkd)"
									:class="chooseNotionlist[4] == 0 ? 'a-screen current' : 'a-screen'">全部</span>
								<span v-for="(item, index) in notionlist4" :key="'notionlist4' + index"
									:class="chooseNotionlist[4] == item.value ? 'a-screen current' : 'a-screen'"
									@click="chooseNotion(5, 'a', item)">{{ item.label }}</span>
							</dd>
						</dl>
					</div>
				</div>
				<div class="whitebox ">
					<div class="enterprise_list_box dborder-bottom">
						<div class="enterparise_guide oh" style="width: 95%; ">
							<p class="fl" v-if="!kwtextsearch">产业大脑为您找到<span class="searchnum">{{ total }}</span>条相关结果</p>
							<p class="fl" v-if="kwtextsearch">产业大脑为您找到<span class="searchnum">{{ total }}</span>条【 <span
									class="orangefont">{{ kwtextsearchtext }}</span>】相关结果</p>
						</div>
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table"
							v-show="enterpirseList.length != 0">
							<tr>
								<th class="xuhaotd">序号</th>
								<th>企业名称 </th>
								<th>地区</th>
								<th>员工人数</th>
								<!-- <th>级别</th>  
							<th>类别</th>  -->
								<th>研究领域</th>
							</tr>
							<tr v-for="(list, index) in enterpirseList">
								<td>{{ (page - 1) * pageSize + index + 1 }}</td>
								<td class="title" @click="routerlinkid('/resources-enterprises', list.id,)">
									{{ list.title }}</td>
								<td>{{ list.area }}</td>
								<td>{{ list.insurePerson }}</td>
								<!-- 	<td>{{list.area}}</td>
							<td>{{list.area}}</td> -->
								<td :class="list.notion == '' ? 'conpanytags' : 'conpanytags hastag'">
									<span class="span-tag" v-for="item in list.notionlist"
										@click="tagrouter('/enterpriseTag', 7, 'notion', item.id, item.name)">{{ item.name }}</span>
									<i v-show="list.notionlist.length == 0" style="color:#999">-</i>
								</td>
							</tr>
							</tr>
						</table>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"> </zpagenav>
					</div>
				</div>
			</div>
		</div>


		<footerbar v-if="userdata.userType > 1"></footerbar>
	</div>
</template>

<script>
import $ from "jquery";
import { dataInJs } from "../../utils/city.js";
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'innovativeResources',
	computed: {
		...mapState({
			// isCollapse: (state) => state.app.isCollapse,
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			title: "科研机构",
			fenkd: { children: [] },
			selectcitydata: [],
			notionlist: [],
			notionlist1: [],
			notionlist2: [],
			notionlist3: [],
			notionlist4: [],
			notionlist5: [],
			notionlist6: [], notionbtn: false, notionbtn1: false, notiontext: '', notionCode: 0, chooseNotionlist: [0, 0, 0, 0, 0],
			page: 1, //显示的是哪一页
			haspage: true, //是否还有下一页
			pageSize: 10, //每一页显示的数据条数
			total: 1, //记录总数
			total1: 1, //记录总数
			totalPage: 1,
			maxPage: 10, //最大页数
			provinceid: 0,
			cityid: 0,
			countyid: 0,
			provincedata: [],
			citydata: [],
			countydata: [],
			enterpirseList: [],
			num: 1,
			curindex: 4,
			websitetype: '中投顾问-创新资源',
			userheadname: [
				{ type: 1, name: '科研机构', curindex: 4 },
				{ type: 2, name: '创新资源', curindex: 5 },
				{ type: 3, name: '创新技术资源', curindex: 4 },
				{ type: 4, name: '创新技术资源', curindex: 3 },
				{ type: 5, name: '创新机构库', curindex: 5 },
			],
			userdata: {},
			searchtext: "",
			kwtextsearch: false,
			kwtextsearchtext: "",
			usernotionlistsave1: [],//用户默认概念数据
			isShowFreeUserTips: false,
		}
	},
	beforeCreate() {
		this.bus.$emit('loading', true);
	},
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
		var _this = this;
		this.userdata = this.getuseriformation();
		// this.getuserinfor(); 
		this.getNotionAllList();
		this.provincedata = dataInJs();
	},
	mounted() {
		document.getElementById('app').style.background = "#f0f3f5";
		// console.log(this.$route.params.categoryid)
		var _this = this;
		this.pageHandler(1);
	},
	methods: {
		//获取一级概念数据列
		getNotionAllList() {
			var ajaxurl = this.$api.tag.notion.list() + '?level=5';
			var _this = this;
			this.getAxiosData(ajaxurl, this.userdata.token, function (res) {
				_this.notionlist = res.list;
				_this.flag = true;
			})
		},
		//概念单选 层级显示
		chooseNotion(step, type, data) {
			if (!this.userdata.token) {
				this.isShowFreeUserTips = true;
				return;
			}
			if (type == 'all') {
				this.notionCode = this.chooseNotionlist[step - 2];
				this.chooseNotionlist[step - 1] = '0';
			} else {
				this.chooseNotionlist[step - 1] = data.value;
				for (var i = 0; i < this.chooseNotionlist.length; i++) {
					if (i > step - 1) {
						this.chooseNotionlist[i] = '0';
					}
				}
				this.notionCode = data.value;
			}
			if (data.children != null) {
				if (step == 1) {
					this.notionlist1 = data.children.filter(list => {
						return list.label != '环保';
					});
					// console.log(this.notionlist1)
					this.notionlist2 = []; this.notionlist3 = []; this.notionlist4 = [];
				} else if (step == 2) {
					this.notionlist2 = data.children;
					this.notionlist3 = []; this.notionlist4 = [];
				} else if (step == 3) {
					this.notionlist3 = data.children; this.notionlist4 = [];
				} else if (step == 4) {
					this.notionlist4 = data.children; this.notionlist5 = [];
				} else if (step == 5) {
					this.notionlist5 = data.children;
				}
			}
			// console.log(this.chooseNotionlist);
			this.ajaxsearchcompany();
		},
		//省份城市选择
		provincechoose(id, i) {
			if (!this.userdata.token) {
				this.isShowFreeUserTips = true;
				return;
			}
			this.provinceid = id;
			this.cityid = 0;
			this.countyid = 0;
			this.countydata = [];
			if (i != "all" && this.provincedata[i].children != null) {
				this.citydata = this.provincedata[i].children;
			} else {
				this.citydata = [];
			}
			this.page = 1;
			this.ajaxsearchcompany();
		},
		choosecity(id, i) {
			//	console.log('choosecity',id);
			this.cityid = id;
			this.countyid = 0;
			if (i != "all" && this.citydata[i].children != null) {
				this.countydata = this.citydata[i].children;
			} else {
				this.countydata = [];
			}
			this.page = 1;
			this.ajaxsearchcompany();
		},
		choosecounty(id) {
			//	console.log('choosecity',id);
			this.countyid = id;
			this.page = 1;
			this.ajaxsearchcompany();
		},
		//公用部分
		searchenter(e) {
			if (e.keyCode == 13) {
				this.searchkwfun();
			}
		},
		searchkwfun() {
			if (!this.userdata.token) {
				this.isShowFreeUserTips = true;
				this.searchtext='';
				return;
			}
			this.searchtext = $.trim(this.searchtext);
			// if(this.searchtext!="" || ){
			console.log(this.searchtext);
			this.ajaxsearchcompany();
			// } 
		},
		getuserinfor() {
			this.userdata = this.getuseriformation();
			// this.industryid = this.userdata.industry; 
			this.usernotionlistsave = this.taglistfun(this.userdata.notionText, this.userdata.notion);
			this.usernotionlistsave1 = this.taglistfun(this.userdata.notionText, this.userdata.notion);
			var _this = this;
			this.userheadname.forEach((data) => {
				if (data.type == _this.userdata.userType) {
					_this.websitetype = data.name;
					_this.curindex = data.curindex;
				}
			})
		},
		pageHandler: function (page) {
			this.page = page;
			this.ajaxsearchcompany(page);
		},
		ajaxsearchcompany(pages) {
			this.bus.$emit('loading', true);
			var _this = this;
			this.page = pages ? pages : 1;;
			var notionja = this.splicing('notion', this.notionCode);
			var kwaja = this.splicing('kw', this.searchtext);
			var countyidja = this.splicing('county', this.countyid);
			var provinceidja = this.splicing('province', this.provinceid);
			var cityidja = this.splicing('city', this.cityid);
			let url2 = this.$api.cyl.academy.list() + '?page=' + this.page + notionja + kwaja + countyidja + provinceidja + cityidja;
			this.$axios.get(url2, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log(res.data, url2);
				if (res.data.success) {
					// console.log(url2);
					_this.enterpirseList = res.data.list;
					for (var i = 0; i < res.data.list.length; i++) {
						if (_this.enterpirseList[i].notion != "" && _this.enterpirseList[i].notion != null) {
							_this.enterpirseList[i].notionlist = _this.taglistfun(_this.enterpirseList[i].notion, _this.enterpirseList[i].notionCode);
						} else {
							_this.enterpirseList[i].notionlist = [];
						}
					}
					_this.bus.$emit('loading', false);
					_this.totalPage = res.data.totalPage;
					_this.pageSize = res.data.pageSize;
					_this.total = res.data.totalRecord;
					_this.haspage = res.data.list.length == res.data.pageSize;
					_this.kwtextsearch = _this.searchtext != ''
					_this.kwtextsearchtext = _this.searchtext;
					//导航栏筛选 研究机构暂没有城市地图 
					if (citytest != null) {
						var citylistd = [], citytest = res.data.cityList;
						for (var i = 0; i < citytest.length; i++) {
							let citylista = {};
							citylista.value = citytest[i].count;
							citylista.id = citytest[i].id;
							citylista.name = _this.citynameremove(citytest[i].name);
							citylista.data = [];
							for (var p = 0; p < citytest[i].children.length; p++) {
								let citydtac = {};
								citydtac.value = citytest[i].children[p].count;
								citydtac.id = citytest[i].children[p].id;
								citydtac.name = citytest[i].children[p].name;
								citylista.data.push(citydtac);
							}
							citylistd.push(citylista);
						};
						if (!_this.cityflag) {
							_this.selectcitydata = res.data.cityList;
							_this.citymapdata = citylistd;
							_this.total1 = res.data.totalRecord;
						}
					}

				} else {

				}
			}).catch(function (error) { });
			// console.log(datas);  
		}
	}
}
</script>

<style type="text/css" scoped="scoped">
@import "../../assets/css/zpageNav.css";
</style>
